import Choices from 'choices.js';
import isJSON from '../utils/isJSON';
const allFilters = document.querySelectorAll('[data-sort-by-name],[data-sort-by-number]');
const filterSelect = document.querySelector('#tender-sort');

let selectInstance = false;

if(filterSelect) {

  const filterSelectOptions = JSON.parse(filterSelect.dataset.options)
  selectInstance = new Choices(filterSelect,{
    searchEnabled: false,
    placeholder: true,
    placeholderValue: filterSelectOptions.placeholder,
  });

  selectInstance.passedElement.element.addEventListener('choice', (event) => {
    if(isJSON(event.detail.choice.value)) {
      const options = JSON.parse(event.detail.choice.value);
      const items = document.querySelectorAll(options.selector);

      if(options.type === 'text') {
        sortByNameFunc(options,items);
      }

      if(options.type === 'number') {
        sortByNumberFunc(options,items);
      }
    }
  },false);

}

const sortByName = () => {

  const filters = document.querySelectorAll('[data-sort-by-name]');
  if (filters) {
    filters.forEach(filter => {
      if(isJSON(filter.dataset.sortByName)) {
        let options = JSON.parse(filter.dataset.sortByName);
        const items = document.querySelectorAll(options.selector);

        filter.addEventListener('click', () => {
          if(filter.classList.contains('is-active')) {
            if(options.direction === 'ASC') {
              options.direction = 'DESC';
              filter.classList.remove('is-asc');
              filter.classList.add('is-desc');
            } else if(options.direction === 'DESC') {
              options.direction = 'ASC';
              filter.classList.remove('is-desc');
              filter.classList.add('is-asc');
            }
          }
          sortByNameFunc(options, items);
          filter.classList.add('is-active');
        });
      }
    });
  }
}

const sortByNameFunc = (options,items) => {

    Array.from(items).sort((a, b) => {
      a = a.querySelector(options.column).innerText.toLowerCase()
      b = b.querySelector(options.column).innerText.toLowerCase()
      return (a > b) - (a < b)
    }).forEach((n, i) => {
      if(options.direction === 'ASC') {
        n.style.order = i
      } else {
        n.style.order = -i
      }
    });

    allFilters.forEach(node => {
      node.classList.remove('is-active');
    });
};

const sortByNumber = () => {

  const filters = document.querySelectorAll('[data-sort-by-number]');
  if (filters) {
    filters.forEach(filter => {
      if(isJSON(filter.dataset.sortByNumber)) {
        let options = JSON.parse(filter.dataset.sortByNumber);
        const items = document.querySelectorAll(options.selector);

        filter.addEventListener('click', () => {
          if(filter.classList.contains('is-active')) {
            if(options.direction === 'ASC') {
              options.direction = 'DESC';
              filter.classList.remove('is-asc');
              filter.classList.add('is-desc');
            } else if(options.direction === 'DESC') {
              options.direction = 'ASC';
              filter.classList.remove('is-desc');
              filter.classList.add('is-asc');
            }
          }
          sortByNumberFunc(options, items);
          filter.classList.add('is-active');
        });
      }
    });
  }
}

const sortByNumberFunc = (options,items) => {

  Array.from(items).sort((a, b) => {
    a = a.querySelector(options.column).dataset.number
    b = b.querySelector(options.column).dataset.number
    return (a > b) - (a < b)
  }).forEach((n, i) => {
    if(options.direction === 'ASC') {
      n.style.order = i
    } else {
      n.style.order = -i
    }
  });

  allFilters.forEach(node => {
    node.classList.remove('is-active');
  });
};

sortByName();
sortByNumber();
